export default __webpack_public_path__ + "static/media/ico_tag.bacf2dce.png";